import curry from 'lodash-es/curry';
import createAction from './createAction';

export default (function (type, payloadCreator) {
  return curry(createAction(type, payloadCreator), payloadCreator.length);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-actions/es/createCurriedAction.js
// module id = 1352
// module chunks = 7